<script setup lang="ts">
import { ChevronRight } from 'lucide-vue-next'
import { DropdownMenuSubTrigger, type DropdownMenuSubTriggerProps, useForwardProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

// eslint-disable-next-line unicorn/prevent-abbreviations
const props = defineProps<DropdownMenuSubTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

// eslint-disable-next-line unicorn/prevent-abbreviations
const forwardedProps = useForwardProps(delegatedProperties)
</script>

<template>
  <DropdownMenuSubTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        'flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-base outline-none focus:bg-background-hover data-[state=open]:bg-background-hover',
        props.class,
      )
    "
  >
    <slot />
    <ChevronRight class="ml-auto size-4" />
  </DropdownMenuSubTrigger>
</template>
